import React from 'react';
import {MENUS} from '../../../../../../utils/query_utils';
import {queryBuilderState} from '../../../../../../services/query_builder_state';
import DatasetAttributeInput from '../dataset_attribute_input';
import DatasetAttributeComponent from '../dataset_attribute';
import {FEATURE_FLAGS} from "../../../../../../services/feature_flags";

export default class FilterAttribute extends DatasetAttributeComponent {
    logicalOperatorInput = null;
    operatorInput = null;
    valueInput = null;

    componentDidUpdate() {
        super.componentDidUpdate();
        if (this.state.focusNextInput) {
            switch (queryBuilderState.menu) {
                case MENUS.FILTER_OPERATOR:
                    this.operatorInput.focusInput();
                    break;
                case MENUS.FILTER_VALUE:
                    this.valueInput.focusInput();
                    break;
                case MENUS.FILTER_LOGICAL_OPERATOR:
                    this.logicalOperatorInput.focusInput();
                    break;
                default:
                    break;
            }
        }
    }

    componentWillUnmount() {
        this.unbindNextMenuListener();
    }

    canRemove() {
        return this.props.attribute.column;
    }

    renderAttribute() {
        const {attribute, firstInList, datasetOpen} = this.props;
        const showOtherInputs = !!attribute.column;

        if (!datasetOpen && this.isLast()) {
            return;
        }
        return (
            <>
                {!firstInList && attribute.column && !FEATURE_FLAGS.FILTERS_BESIDE &&
                    /*
                    <DatasetAttributeInput
                        attribute={attribute}
                        propName="logicalOperator"
                        valueProp="label"
                        placeholder="and"
                        menu={MENUS.FILTER_LOGICAL_OPERATOR}
                        ref={(el) => { this.logicalOperatorInput = el; }}
                    />
                    */
                    <span className="query-builder-filler" style={{cursor: 'text', 'paddingTop': '5px'}}>and</span>
                }
                <DatasetAttributeInput
                    attribute={attribute}
                    propName="column"
                    valueProp="fullName"
                    placeholder="+ Add Filter"
                    focusedPlaceholder="Search for column name"
                    menu={MENUS.COLUMN}
                    ref={(el) => { this.columnInput = el; }}
                />
                {showOtherInputs && (
                    <>
                        <DatasetAttributeInput
                            attribute={attribute}
                            propName="operator"
                            valueProp="label"
                            placeholder="is"
                            menu={MENUS.FILTER_OPERATOR}
                            ref={(el) => { this.operatorInput = el; }}
                        />
                        <DatasetAttributeInput
                            attribute={attribute}
                            propName="values"
                            valueProp="0"
                            placeholder="type filter value"
                            menu={MENUS.FILTER_VALUE}
                            ref={(el) => { this.valueInput = el; }}
                        />
                    </>
                )}
            </>
        )
    }

    renderPostAttribute() {
        const {attribute, position, totalAttributes} = this.props;
        const lastInList = position === totalAttributes - 2;
        if (!lastInList && attribute.isComplete() && FEATURE_FLAGS.FILTERS_BESIDE) {
            return <span className="query-builder-filler" style={{cursor: 'text', 'paddingTop': '5px'}}>and</span>;
        }

        return null;
    }
}
